import { useEffect, useState } from 'react';

/**
 * `value`, but only after it has stopped changing for `delayMs`.
 *
 * Every search box in the app waits before issuing a request; this is the one
 * place that waiting is implemented. The list hook, the worklist and the
 * command palette each had their own copy, with three different delays and no
 * shared name for the idea.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
